import React from 'react';
import { connect } from 'react-redux';

import * as Types from 'types';
import { PlaylistContainer } from 'playlists/PlaylistContainer';
import { PlaylistFilter } from 'playlists/components/PlaylistFilter';
import { fetchCurrentUserWishlist } from 'features/wishlist/actions';
import { getUserWishlistListId } from 'features/wishlist/constants';
import { createListToPlaylistSelector } from 'features/playlists/selectors';

type StateProps = {
  playlist: Types.Playlist;
};

type DispatchProps = {
  fetch: (userId: number) => void;
};

type OwnProps = Types.Styleable;

type Props = StateProps & DispatchProps & OwnProps;

type State = {
  filter: string;
};

class WishlistArtworksSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { filter: '' };

    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount() {
    this.props.fetch(sedition.currentUser.id as number);
  }

  handleFilterChange(newFilterValue: string) {
    this.setState({ filter: newFilterValue });
  }

  render() {
    return (
      <div className='artworks-selector'>
        <PlaylistFilter className='mb-1' onChange={this.handleFilterChange} />
        <PlaylistContainer
          items={this.props.playlist.items}
          filterQuery={this.state.filter}
          droppable={false}
          playlistIsEditable={false}
          isEdit
          showFilter
          showAdd
        />
      </div>
    );
  }
}

const mapStateToProps = (state: Types.RootState) => {
  const listId = getUserWishlistListId(sedition.currentUser.id as number);
  const wishlistPlaylistSelector = createListToPlaylistSelector(listId);
  const playlist = wishlistPlaylistSelector(state);

  return {
    playlist,
  };
};

const mapDispatchToProps = {
  fetch: fetchCurrentUserWishlist,
};

export const WishlistArtworksSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WishlistArtworksSelector);
